import { Typography } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookingType } from 'types';
import { getDuration } from 'utils/date';

import { MaintenanceSlot, StyledSlotWrapper } from './time-slot.styles';

export type MaintenanceSlotData = {
  id: string;
  type: BookingType.Maintenance;
  startDate: string;
  endDate: string;
};

export const MaintenanceTimeSlot = ({
  data,
}: {
  data: MaintenanceSlotData;
}) => {
  const { t } = useTranslation();

  const { startDate, endDate } = data;
  const duration = getDuration(startDate, endDate);

  return (
    <StyledSlotWrapper duration={duration}>
      <MaintenanceSlot>
        <Typography.Text type='secondary' strong>
          {t('bookingTypes.maintenance')}
        </Typography.Text>
      </MaintenanceSlot>
    </StyledSlotWrapper>
  );
};

export const MemoizedMaintenanceTimeSlot = React.memo(MaintenanceTimeSlot);
